"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "姓名",
        prop: "displayName",
        isShow: true,
        width: "100"
      }, {
        name: "登录账号",
        prop: "userCode",
        isShow: true,
        width: "150"
      }, {
        name: "邮箱",
        prop: "email",
        isShow: true,
        width: "150"
      }, {
        name: "身份证号",
        prop: "idCard",
        isShow: true,
        width: "150"
      }, {
        name: "电话",
        prop: "mobilePhone",
        isShow: true,
        width: "150"
      }, {
        name: "是否禁用",
        prop: "isLock",
        isShow: true,
        width: "100",
        isFormats: true
      }],
      funBtns: [{
        size: "small",
        click: "unLock",
        icon: "el-icon-circle-check",
        name: "取消禁用",
        type: "primary"
      }, {
        size: "small",
        click: "Lock",
        icon: "el-icon-circle-close",
        name: "禁用",
        type: "danger"
      }, {
        size: "small",
        click: "resetPassword",
        icon: "el-icon-refresh",
        name: "重置密码",
        type: "primary"
      }, {
        size: "small",
        click: "moreDelete",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "modify",
        span: 3
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  methods: {
    listBureau: function listBureau() {},
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels() {},
    // 新增
    saveBureau: function saveBureau() {
      this.$router.push("/test/school-add");
    },
    editBureau: function editBureau() {},
    handleSelectionChange: function handleSelectionChange() {},
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange() {},
    handleSizeChange: function handleSizeChange() {}
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};